import { Component, OnInit, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LgTranslateService } from "@logex/framework/lg-localization";

import { LOCAL_STORAGE_LOGOUT_URL_KEY } from "./shared/services/public-pages-guard";
import { LG_USER_INFO } from "@logex/framework/lg-application";
import {
    SharedAppUser,
    SharedConfigService
} from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";

@Component({
    selector: "mrdm-self-service-frontend-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
    private _router = inject(Router);
    private _title = inject(Title);
    private _translate = inject(LgTranslateService);
    private _configService = inject(SharedConfigService);
    _userInfo = inject<SharedAppUser>(LG_USER_INFO);

    _links = this._configService.links;

    constructor() {
        this._title.setTitle(this._translate.translate("APP.Title.Main"));
    }

    ngOnInit(): void {
        const logoutUrl = localStorage.getItem(LOCAL_STORAGE_LOGOUT_URL_KEY);
        if (logoutUrl) {
            localStorage.removeItem(LOCAL_STORAGE_LOGOUT_URL_KEY);
            this._router.navigate([logoutUrl]);
        }
    }
}
